import {
  startOfDay, endOfDay, startOfYear, endOfYear,
  startOfWeek, endOfWeek, startOfMonth, endOfMonth, startOfQuarter, endOfQuarter
} from 'date-fns'
import { MessageService } from '../shared/components/framework/services/message.service';

export type DatePanelItem = { text: string, startDate: Date, endDate: Date, key: number, type: string };

export type DatePanelItems = { name: string; selectedItem: string; items: DatePanelItem[] };

export type Dates = { startDate: Date, endDate: Date };

export enum DueOptions {
  Today = 'Today',
  Week = 'Week',
  Month = 'Month',
  Quarter = 'Quarter',
  Year = 'Year',
  All = 'All'
}

export enum ScopeOptions {
  MyTask = 'My Subtasks',
  MyTeamTask = 'My Team Tasks',
  All = 'All',
  // SubtasksWithAttachments = 'My Subtasks with Attachments'
}

export const datePanelItems: Array<DatePanelItems> = [
  {
    name: 'Due',
    selectedItem: null, // Holds the selected item for the "Scope" group
    items: [
      {
        text: DueOptions.Today,
        startDate: getDayStart(),
        endDate: getDayEnd(),
        key: 0,
        type: 'Due'
      },
      {
        text: DueOptions.Week,
        startDate: getWeekStartDate(),
        endDate: getWeekEndDate(),
        key: 1,
        type: 'Due'
      },
      {
        text: DueOptions.Month,
        startDate: getMonthStartDate(),
        endDate: getMonthEndDate(),
        key: 2,
        type: 'Due'
      },
      {
        text: DueOptions.Quarter,
        startDate: getQuarterStartDate(),
        endDate: getQuarterEndDate(),
        key: 3,
        type: 'Due'
      },
      {
        text: DueOptions.Year,
        startDate: getYearStart(),
        endDate: getYearEnd(),
        key: 4,
        type: 'Due'
      },
      {
        text: DueOptions.All,
        startDate: null,
        endDate: null,
        key: 5,
        type: 'Due'
      }
    ]
  },
  {
    name: 'Scope',
    selectedItem: null, // Holds the selected item for the "Scope" group
    items: [
      {
        text: ScopeOptions.MyTask,
        startDate: getDayStart(),
        endDate: getDayEnd(),
        key: 0,
        type: 'Scope'
      },
      // {
      //   text: ScopeOptions.SubtasksWithAttachments,
      //   startDate: getDayStart(),
      //   endDate: getDayEnd(),
      //   key: 3,
      //   type: 'Scope'
      // },
      {
        text: ScopeOptions.MyTeamTask,
        startDate: getDayStart(),
        endDate: getDayEnd(),
        key: 1,
        type: 'Scope'
      },
      {
        text: ScopeOptions.All,
        startDate: getDayStart(),
        endDate: getDayEnd(),
        key: 2,
        type: 'Scope'
      }
    ]
  }
];


export function getNotificationTimeout(): number {
  return 5000;
}

export function formatAndCapitalize(value: string): string {
  if (!value) return value;
  return value
    .replace(/([A-Z])/g, ' $1')
    .trim()  // Remove leading spaces
    .replace(/^./, char => char.toUpperCase());
}

export function filterLoanData(loanData: any[], showInactiveLoans: boolean): any[] {
  if (!showInactiveLoans) {
    return loanData.filter(loan => loan.status !== 'Inactive');
  }
  return loanData;
}

export function filterDealData(dealData: any[], showInactiveDeals: boolean): any[] {
  if (!showInactiveDeals) {
    var activeDeals = dealData.filter(deal => deal.isActive == true);
    return activeDeals;
  }
  return dealData;
}

export const docVaultAuthenticationKey: string = "docVaultAuthenticationKey";

export function getYearEnd() {
  return endOfYear(new Date());
}

export function getYearStart() {
  return startOfYear(new Date());
}

export function getDayStart() {
  return startOfDay(new Date());
}

export function getDayEnd() {
  return endOfDay(new Date());
}

export function getWeekStartDate() {
  return startOfWeek(new Date(), { weekStartsOn: 1 });
}

export function getWeekEndDate() {
  return endOfWeek(new Date(), { weekStartsOn: 1 });
}

export function getMonthStartDate() {
  return startOfMonth(new Date());
}

export function getMonthEndDate() {
  return endOfMonth(new Date());
}

export function getQuarterStartDate() {
  return startOfQuarter(new Date());
}

export function getQuarterEndDate() {
  return endOfQuarter(new Date());
}

export function getDialogYesNoOptions(title: string, message: string) {
  return {
    title: title,
    messageHtml: message,
    buttons: [
      { text: "Yes", onClick: () => true },
      { text: "No", onClick: () => false }
    ]
  };
}

export function sendNotificationMessage(message: string, messageService: MessageService, soundAlert: boolean = false) {
  messageService.changeMessage(message, soundAlert);
  localStorage.setItem('notificationMessage', message);
}





